/**
 * wcgwactions.js
 * Created by calhosh on 11/23/2020.
 */

import * as types from "../actiontypes";
import {API_RESOURCES, createApiReadAction} from '../../util/api';


export const updateWcgw = (url, data) => {
	return {
		type: types.PUT_WCGW,
		meta: {
			api: {
				url,
				method: 'PUT',
				data: data
			}
		}
	};
};

export const getAllWCGWs = (engagementId, queryParameters) => {
	return createApiReadAction(
		types.GET_WCGWS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.WCGWS]: undefined
		},
		queryParameters
	);
};